function OrdersIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="99"
      fill="none"
      viewBox="0 0 100 99"
      {...props}
    >
      <g filter="url(#filter0_d_200_42)">
        <circle cx="49.645" cy="44.645" r="39.645" fill="#EE9280"></circle>
        <circle
          cx="49.645"
          cy="44.645"
          r="37.645"
          stroke="#fff"
          strokeWidth="4"
        ></circle>
      </g>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M37.027 40.686l.67 8.923a7.033 7.033 0 006.936 6.591h9.73a7.033 7.033 0 006.939-6.59l.669-8.924A7.067 7.067 0 0055.03 33H43.966a7.067 7.067 0 00-6.939 7.686z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M54.852 40.139a5.354 5.354 0 11-10.708 0"
      ></path>
      <defs>
        <filter
          id="filter0_d_200_42"
          width="99.291"
          height="99.291"
          x="0"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="5"></feOffset>
          <feGaussianBlur stdDeviation="5"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_200_42"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_200_42"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

export default OrdersIcon;
